<div class="content-header">
  <h1>Confirmation Email</h1>
  <div class="header-actions">
    @if (authStore.canEdit()) {
      <sdc-button
        variant="primary"
        [disabled]="isLoading"
        [attr.data-cy]="'email-send-demo-button'"
        (onClick)="sendDemoEmail()">
        <span>Send Demo</span>
        <ng-icon name="lucideSend" aria-hidden="true" />
      </sdc-button>
    }
    <sdc-button
      variant="primary"
      [disabled]="isLoading"
      [attr.data-cy]="'email-preview-button'"
      (onClick)="openModalPreview()">
      <span>{{ isLoading ? 'Loading…' : 'Preview' }}</span>
      <ng-icon name="lucideEye" aria-hidden="true" />
    </sdc-button>
    @if (authStore.canEdit()) {
      <sdc-button
        variant="success"
        [disabled]="isSaving"
        [attr.data-cy]="'email-save-button'"
        (onClick)="onSave()">
        <span>{{ isSaving ? 'Saving...' : 'Save Changes' }}</span>
      </sdc-button>
    }
  </div>
</div>

<div class="email-card gs-fill">
  <div class="email-form" [attr.data-cy]="'email-form'">
    <div class="image-field" [class.field-invalid]="hashValidator.logo">
      <sdc-file-upload
        name="logo-upload"
        [class.has-image]="!!imagePreviews.logo"
        [style.--email-image]="dropzoneImage('logo')"
        label="Logo*"
        formatsHint="(jpeg, png)"
        accept="image/*"
        placeholder="Drag&Drop to Add an image"
        [disabled]="!authStore.canEdit()"
        (filesChange)="onFilesChange($event, 'logo')" />
      @if (hashValidator.logo) {
        <span class="field-error"
          >This entry is mandatory. Please upload a valid image.</span
        >
      }
    </div>

    <div class="image-field" [class.field-invalid]="hashValidator.headerBanner">
      <sdc-file-upload
        name="header-upload"
        [class.has-image]="!!imagePreviews.headerBanner"
        [style.--email-image]="dropzoneImage('headerBanner')"
        label="Head Banner Image*"
        formatsHint="(jpeg, png)"
        accept="image/*"
        placeholder="Drag&Drop to Add an image"
        [disabled]="!authStore.canEdit()"
        (filesChange)="onFilesChange($event, 'headerBanner')" />
      @if (hashValidator.headerBanner) {
        <span class="field-error"
          >This entry is mandatory. Please upload a valid image.</span
        >
      }
    </div>

    <div class="image-field" [class.field-invalid]="hashValidator.footerBanner">
      <sdc-file-upload
        name="footer-upload"
        [class.has-image]="!!imagePreviews.footerBanner"
        [style.--email-image]="dropzoneImage('footerBanner')"
        label="Footer Banner Image"
        formatsHint="(jpeg, png)"
        accept="image/*"
        placeholder="Drag&Drop to Add an image"
        [disabled]="!authStore.canEdit()"
        (filesChange)="onFilesChange($event, 'footerBanner')" />
      @if (hashValidator.footerBanner) {
        <span class="field-error">This entry must be a valid image.</span>
      }
      @if (imagePreviews.footerBanner && authStore.canEdit()) {
        <sdc-button
          variant="destructive"
          size="sm"
          [disabled]="isRemovingFooterBanner || isSaving"
          (onClick)="onRemoveFooterBanner($event)">
          {{ isRemovingFooterBanner ? 'Removing...' : 'Remove' }}
        </sdc-button>
      }
    </div>

    <div class="text-field">
      <span class="field-label">Greeting text</span>
      <sdc-rich-text-editor
        name="greeting-text"
        [control]="greetingTextControl"
        toolbarPreset="minimal"
        placeholder="Enter greeting text…" />
    </div>

    <div class="text-field">
      <span class="field-label">Legal Text*</span>
      <sdc-rich-text-editor
        name="legal-text"
        [control]="legalTextControl"
        toolbarPreset="minimal"
        placeholder="Enter legal text…"
        errorDisplayMode="always"
        errorMessage="This entry is mandatory. Please check for line breaks or spaces." />
    </div>

    <div
      class="text-field"
      [title]="enabledControl.value ? 'Enabled' : 'Disabled'">
      <span class="field-label">Enable Template</span>
      <sdc-checkbox
        label="Enabled"
        labelPosition="right"
        name="email-template-enabled"
        [control]="enabledControl" />
    </div>
  </div>

  <div class="email-divider" aria-hidden="true"></div>

  <div class="email-preview-pane">
    @if (livePreviewHtml) {
      <iframe
        class="email-preview"
        title="Confirmation email preview"
        [srcdoc]="livePreviewHtml"
        [attr.data-cy]="'email-live-preview'"></iframe>
    } @else if (livePreviewFailed) {
      <p class="preview-message">Preview unavailable</p>
    }

    @if (isLivePreviewLoading) {
      <gs-loader
        mode="contained"
        label="Loading preview"
        [attr.data-cy]="'email-preview-loading'" />
    }
  </div>
</div>
